import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { WidgetComponent } from 'src/app/views/dashboard/widgets/widget/widget.component';
import { IWidget, ISingleSourceSingleValueWidget, SharedPoint, DashboardSelection, TimeSeriesDetail } from "src/app/models/dashboard";
import { Widget, Dashboard, } from 'src/api/models'
import { AbstractDataService } from 'src/service/data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DashboardEventService } from '../dashboard-event.service';

@Component({
  template: ""
})
export class SingleSourceSingleValueWidget implements OnInit, IWidget {
  @Output() dashboardSelected: EventEmitter<DashboardSelection>;
  @Output() widgetSelected = new EventEmitter<any>();
  state:any;
  widgetComponent: WidgetComponent;
  widget: Widget;
  dashboard: Dashboard;
  uri: string;
  config: ISingleSourceSingleValueWidget;
  point: SharedPoint;
  
  loadComplete(): void {
    
  }

  constructor(public dataService: AbstractDataService, public sanitizer: DomSanitizer, public events: DashboardEventService) {}

  ngOnInit() {
    this.config = <ISingleSourceSingleValueWidget>(<any>this.widget);

    if (!this.config.timeSeries) {
      this.config.timeSeries = { uri: null,transforms:null,sourceType:null,tagMatches:null,type:null,forceEmbed:false} as TimeSeriesDetail;
    } else {
      // todo - plug into api
      // this.point = this.realTime.registerPoint(this.config.timeSeries.uri, false);
      
    }
  }
}
